var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-management-wrapper"},[_c('h2',[_vm._v("Dealers")]),_c('hr'),_c('div',{staticClass:"user-management"},[_c('BasicDataGrid',{attrs:{"dataSource":_vm.dealers,"multiSelect":false,"columns":_vm.columns,"showColumnLines":false,"actions":_vm.actions},on:{"editUsers":_vm.loadDealerUsers,"editDealer":_vm.loadDealerProfile}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }